import React from 'react'
import papa from 'papaparse'

interface Args {
  data?: object[]
}

export const useDownloadableCsv = ({ data }: Args): string | undefined => {
  const [downloadableDataUrl, setDownloadableDataUrl] = React.useState<string>()

  React.useEffect(() => {
    if (data && !downloadableDataUrl) {
      const csv = papa.unparse(data, { header: true })
      const dataBlob = new Blob([csv], { type: 'text/csv' })
      setDownloadableDataUrl(window.URL.createObjectURL(dataBlob))
    }
    return () => {
      if (downloadableDataUrl) {
        window.URL.revokeObjectURL(downloadableDataUrl)
        setDownloadableDataUrl('')
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [downloadableDataUrl, JSON.stringify(data)])

  return downloadableDataUrl
}
